export const mutations = {
  MutationsSendEmailVerificationLoadingStatus(state, status) {
    state.sendEmailVerificationLoadingStatus = status;
  },
  MutationsGetVerifyEmail(state, status) {
    state.verifyEmail = status;
  },
  MutationsGetVerifyEmailLoadingStatus(state, status) {
    state.verifyEmailLoadingStatus = status;
  },
};
